import { render } from "./SelectorItem.vue?vue&type=template&id=f0785896&scoped=true&ts=true"
import script from "./SelectorItem.vue?vue&type=script&lang=ts"
export * from "./SelectorItem.vue?vue&type=script&lang=ts"

import "./SelectorItem.vue?vue&type=style&index=0&id=f0785896&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0785896"]])

export default __exports__